<template>
  <a-modal
    :title="info?'编辑收件人信息':'收件人信息'"
    :visible.sync="visible"
    :width="700"
    :footer="null"
    @cancel="cancel"
  >
    <RecieverForm v-if="visible" :info="info" :address-type="addressType" @cancel="cancel" @success="succsess" />
  </a-modal>
</template>
<script>
import RecieverForm from './recieverForm'
export default {
  components: {
    RecieverForm
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    addressType: {
      type: Number,
      default: 1
    },
    info: {
      type: Object,
      default: null
    }

  },

  data() {
    return {
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    succsess(res) {
      this.$emit(!this.info ? 'success' : 'edit', res)
      this.$emit('update:visible', false)
    }
  }
}
</script>
